//functional imports
import React, { useState, useEffect } from 'react';
import moment from "moment";
import Collapsible from 'react-collapsible';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import useCopy from '@react-hook/copy'
import { useWindowSize } from '@react-hook/window-size'
import { AutoSuggest } from "react-autosuggestions";
import LoadingOverlay from 'react-loading-overlay';
// React-boostrap componets import
import { Container, Button, Row, Col, Image, Modal, Form, Popover, OverlayTrigger, Spinner } from 'react-bootstrap';
//custom componets
import PageHeader from "../../components/PageHeader";
import Footer from "../../components/Footer";
import Card from "../../components/card/index.js";
import MultilineText from "../../components/MultilineText"

//repos import
import { fetchFeedback, postReport, fetchMetaData } from "../../repository/repo";

//main css
//static files
import make_a_report_bg from '../../assets/images/make_a_report.svg';
import track_report_bg from '../../assets/images/track_report_bg.svg';
import how_bg from '../../assets/images/how_bg.svg';
import faq_bg from '../../assets/images/faq_bg.svg';
import draft_line_icon from "../../assets/images/draft_line_icon.svg"
import foot_print_line from "../../assets/images/footprint-line.svg"
import lightbulb from "../../assets/images/lightbulb-flash-line.svg"
import question_line from "../../assets/images/question-line.svg"
import phone_icon from "../../assets/images/phone_icon.svg"
import form_icon from "../../assets/images/form_icon.svg"
import mail_icon from "../../assets/images/mail_icon.svg"
import post_icon from "../../assets/images/post_icon.svg"
import hiw_img from "../../assets/images/hiw_img.svg"
import message_icon from "../../assets/images/message_icon.svg"
import arrow_back from "../../assets/images/arrow_back.svg"
import copy_icon from "../../assets/images/copy_icon.svg"
import green_copy_icon from "../../assets/images/green_copy_icon.svg"
import tick_icon from "../../assets/images/tick_icon.svg"
import open_icon from "../../assets/images/open.svg"
import close_icon from "../../assets/images/close.svg"

import { faqs } from "../../config/faqs"
import {config} from "../../config/index";


//css modules
import style from "./css/home.module.css"

const allowedUploadTypes = {
    jpg: ["image/jpeg"],
    jpeg: ["image/jpeg"],
    png: ["image/png"],
    gif: ["image/gif"],
    webp: ["image/webp"],
    mp3: ["audio/mpeg"],
    wav: ["audio/wav", "audio/x-wav"],
    m4a: ["audio/mp4", "audio/x-m4a"],
    aac: ["audio/aac"],
    flac: ["audio/flac"],
    ogg: ["audio/ogg", "video/ogg"],
    mp4: ["video/mp4"],
    webm: ["video/webm"],
    mov: ["video/quicktime"],
    avi: ["video/x-msvideo"]
};

const isAllowedUpload = (file) => {
    const filenameMatch = file.name.toLowerCase().match(/^[a-z0-9_-]+\.([a-z0-9]+)$/);

    if (!filenameMatch) {
        return false;
    }

    const allowedMimeTypes = allowedUploadTypes[filenameMatch[1]];
    return allowedMimeTypes?.includes(file.type.toLowerCase()) === true;
};

const allowedUploadExtensions = Object.keys(allowedUploadTypes)
    .map((extension) => `.${extension}`)
    .join(",");

const popover = (

    <Popover id="popover-basic" style={{ backgroundColor: "black" }}>
        <Popover.Content style={{ color: "white", fontFamily: "Circular Std" }}>
            Copied 👍🏽
      </Popover.Content>
    </Popover>
);


const Home = () => {
    //get window dimension
    const [width, height] = useWindowSize();
    //state defination
    const [homeState, setHomeState] = useState({ fetchingMetaData: false, clientList: [], rawClientList:[], IncidentTypeList: [], showReportChannelModal: false, showReportSuccess: false, showTrackReportModal: false, showHiwModal: false, showFaqModal: false, showFeedback: false, showReportMenu: true, showForm: false, showEmail: false, showCall: false, showPost: false, reportFeedback: null, fetchingFeedback: false, sendingReport: false, refNo: null })
    const [feedbackFormData, setFeedbackFormData] = useState({});
    const [reportFormData, setReportFormData] = useState({});
    //custom hook to copy to clipboard from https://www.npmjs.com/package/@react-hook/copy
    const { copy } = useCopy(homeState.refNo)
    //for auto suggestion for organization field
    const [client, setClient] = React.useState();


    //run once on page loads
    useEffect(async () => {
        // update client list and incident types from API
        //make api call
        const res = await fetchMetaData();
        //fectch current state snapshot
        let _state = { ...homeState }
        if (res.code == 200) {
            const organisations = res.data.Organisations;
            const incidentTypes = res.data.IncidentTypes;
            //update
            let formattedClientList = []
            let _rawClientList=[];
            for (let index = 0; index < organisations.length; index++) {
                const element = organisations[index];
                formattedClientList[index] = { name: element.Name, value: element.Name, abbr: element.CodeName }
                _rawClientList.push(element.Name)
            }
            //set state
            _state.clientList = formattedClientList;
            _state.rawClientList = _rawClientList;
            _state.IncidentTypeList = incidentTypes;
            _state.fetchingMetaData = false;
            setHomeState(_state);
        } else {
            //set state
            _state.clientList = [{ name: "NA", value: "NA", abbr:"NA"}];
            _state.rawClientList = ["NA"];
            _state.IncidentTypeList = [{Name:"NA"}];
            _state.fetchingMetaData = false;
            setHomeState(_state);
            // toast.error("Unable to load meta data. Please try again later.")
            alert("Unable to load metadata. \n\nPlease check your internet, refresh this page or try again later.")
        }
    }, []);


    //feedback handlers
    const handleFeedbackFormChange = (e) => {
        setFeedbackFormData({
            ...feedbackFormData,
            [e.target.name]: e.target.value.trim(),
        });
        console.log(feedbackFormData)
    };
    const getFeedback = async (event) => {
        event.preventDefault(); //prevent page reload on form submission
        let _state = { ...homeState }
        _state.fetchingFeedback = true; setHomeState(_state);
        const res = await fetchFeedback(feedbackFormData.incidentRefNo);
        if (res.code == 200) {
            handleShowFeedback(JSON.stringify(res.data.Remark));
        } else {
            _state.reportFeedback = null
            _state.fetchingFeedback = false;
            setHomeState(_state);
            toast.error("Unable to get feedback. Please try again later or provide a valid reference number.")
        }
    }

    //submit-report handlers
    const handleReportFormChange = (e) => {
        if (e.target.name === "file") {
            const files = Array.from(e.target.files || []);
            if (files.some((file) => !isAllowedUpload(file))) {
                e.target.value = "";
                setReportFormData({
                    ...reportFormData,
                    file: null,
                });
                toast.error("Only approved audio, image, and video file types can be uploaded.");
                return;
            }

            setReportFormData({
                ...reportFormData,
                file: files,
            });
            return;
        }

        let fieldValue = e.target.value.trim();
        setReportFormData({
            ...reportFormData,
            [e.target.name]: fieldValue,
        });
        console.log(reportFormData)
    };

    const submitReport = async (event) => {
        event.preventDefault(); //prevent page reload on form submission
        //perform form validation here
        if (client) {
            if (homeState.rawClientList.includes(client) && client!=="NA") {
                let _state = { ...homeState }; _state.sendingReport = true; setHomeState(_state);
                //make api call
                const res = await postReport({ ...reportFormData, Organisation: client, source: config.webform_source});
                if (res.code == 200) {
                    handleShowReportSuccessModal(res.data.ReferenceNo);
                } else {
                    let _state = { ...homeState }; _state.refNo = null; _state.sendingReport = false; setHomeState(_state);
                    alert("Unable to submit report. Please try again later." + res.msg)
                }
            } else {
                alert("Orgainization is not among KPMG clients. Please try again.")
            }

        } else {
            let _state = { ...homeState }; _state.refNo = null; _state.sendingReport = false; setHomeState(_state);
            alert("Please select your organization")
        }
    }

    //other handlers
    const handleClose = () => {
        let _state = { ...homeState }
        _state.showReportChannelModal = false
        setHomeState(_state);
    };
    const handleShow = () => {
        let _state = { ...homeState }
        _state.showReportChannelModal = true
        setHomeState(_state);
    };
    const handleCloseReportSuccessModal = () => {
        let _state = { ...homeState }
        _state.showReportSuccess = false
        setHomeState(_state);
    };
    const handleShowReportSuccessModal = (ReferenceNo) => {
        setReportFormData({});
        let _state = { ...homeState }
        _state.sendingReport = false;
        _state.refNo = ReferenceNo;
        _state.showReportSuccess = true;
        _state.showReportChannelModal = false;
        setHomeState(_state);
    };
    const handleCloseTrackReportModal = () => {
        let _state = { ...homeState }
        _state.reportFeedback=null
        _state.showFeedback=false
        _state.showTrackReportModal = false
        setHomeState(_state);
    };
    const handleShowTrackReportModal = () => {
        let _state = { ...homeState }
        _state.showTrackReportModal = true
        setHomeState(_state);
    };
    const handleCloseHiwModal = () => {
        let _state = { ...homeState }
        _state.showHiwModal = false
        setHomeState(_state);
    };
    const handleShowHiwModal = () => {
        let _state = { ...homeState }
        _state.showHiwModal = true
        setHomeState(_state);
    };
    const handleCloseFaqModal = () => {
        let _state = { ...homeState }
        _state.showFaqModal = false
        setHomeState(_state);
    };
    const handleShowFaqModal = () => {
        let _state = { ...homeState }
        _state.showFaqModal = true
        setHomeState(_state);
    };
    const handleCloseFeedback = () => {
        let _state = { ...homeState }
        _state.showFeedback = false
        setHomeState(_state);
    };
    const handleShowFeedback = (feedback) => {
        setFeedbackFormData({});
        let _state = { ...homeState }
        _state.showFeedback = true;
        _state.reportFeedback = feedback;
        _state.fetchingFeedback = false;
        setHomeState(_state);
    };
    // inside make a report modal
    const handleCloseForm = () => {
        setReportFormData({})
        let _state = { ...homeState }
        _state.sendingReport = false;
        _state.showForm = false; _state.showReportMenu = true
        setHomeState(_state);
    };
    const handleShowForm = () => {
        let _state = { ...homeState }
        _state.showForm = true; _state.showEmail = false; _state.showCall = false; _state.showPost = false; _state.showReportMenu = false;
        setHomeState(_state);
    };
    const handleCloseMail = () => {
        let _state = { ...homeState }
        _state.showEmail = false; _state.showReportMenu = true;
        setHomeState(_state);
    };
    const handleShowMail = () => {
        let _state = { ...homeState }
        _state.showForm = false; _state.showEmail = true; _state.showCall = false; _state.showPost = false; _state.showReportMenu = false;
        _state.refNo = "kpmgethicsline@ng.kpmg.com"; // for clipboard copy only
        setHomeState(_state);
    };
    const handleCloseCall = () => {
        let _state = { ...homeState }
        _state.showCall = false; _state.showReportMenu = true;
        setHomeState(_state);
    };

    const handleShowCall = () => {
        let _state = { ...homeState }
        _state.showForm = false; _state.showEmail = false; _state.showCall = true; _state.showPost = false; _state.showReportMenu = false;
        setHomeState(_state);
    };

    const handleClosePost = () => {
        let _state = { ...homeState }
        _state.showPost = false; _state.showReportMenu = true;
        setHomeState(_state);
    };

    const handleShowPost = () => {
        let _state = { ...homeState }
        _state.showForm = false; _state.showEmail = false; _state.showCall = false; _state.showPost = true; _state.showReportMenu = false;
        setHomeState(_state);
    };

    // const [email, setEmail] = useState();
    // const [pass, setPass] = useState();

    // const handleEmailChange = (e) => {
    //     console.log(e.target.value)

    //     let _state={...feedbackFormData};
    //     _state[e.target.name]= e.target.value.trim();
    //     setFeedbackFormData(_state);
    //     // console.log(feedbackFormData)

    // };
    // const handlePasswordChange = (e) => {
    //     setPass(e.target.value)
    // };

    // const handleLogin = () => {
    //     console.log(feedbackFormData)
    //     // console.log("EMail: " + email);
    //     // console.log("Password: " + pass);
    // };

    return (
        <>

            <LoadingOverlay
                active={homeState.fetchingMetaData}
                spinner
                text='Loading'
            >
                <div style={{ width: width, height: height }}>
                    <PageHeader>
                    </PageHeader>

                    <Container>
                        <Row style={{ marginTop: '101px', marginLeft: "0px" }} >
                            <Col >
                                <p style={{ color: "white", fontSize: "60px", fontFamily: "KPMG App" }}>Hello There! Welcome to the <br></br>KPMG Ethics Line</p>
                            </Col>
                        </Row>
                        <Row style={{ marginTop: '66px', marginLeft: "0px" }}>
                            <Col >
                                <p style={{ color: "white", fontSize: "18px" }}>What would you like to do today?</p>
                            </Col>
                        </Row>

                        <Row style={{ marginTop: '26px', marginLeft: "0px" }}>

                            <div onClick={handleShow}>
                                <Card bgUrl={make_a_report_bg} iconUrl={draft_line_icon} titleText="Make a report" noteText="Report an incident of breach of ethics and conduct" />
                            </div>
                            <div onClick={handleShowTrackReportModal}>
                                <Card bgUrl={track_report_bg} iconUrl={foot_print_line} titleText="Track Report" noteText="Follow up on a report" />
                            </div>
                            <div onClick={handleShowHiwModal}>
                                <Card bgUrl={how_bg} iconUrl={lightbulb} titleText="How does it work?" noteText="Details of KPMG Ethics Line" />
                            </div>
                            <div onClick={handleShowFaqModal}>
                                <Card bgUrl={faq_bg} iconUrl={question_line} titleText="FAQs" noteText="See frequently asked questions and the corresponding answers" />
                            </div>

                        </Row>
                    </Container>

                    <Footer>
                        © {moment(new Date().toUTCString()).format("YYYY")} KPMG Advisory Services, a partnership registered in Nigeria and a member firm of the KPMG global organisation of independent member <br></br>firms affiliated with KPMG International Limited, a private English company limited by guarantee. All rights reserved.
                    </Footer>
                </div>

            </LoadingOverlay>




            {/* make a report modal */}
            <Modal show={homeState.showReportChannelModal} onHide={handleClose}   >
                {/* main */}
                {homeState.showReportMenu ?
                    <div>
                        <Modal.Header closeButton style={{ borderColor: "transparent" }}>
                            <Modal.Title style={{ fontSize: "24px" }}>How would you like to make your <br></br>report?</Modal.Title>
                        </Modal.Header>
                        <Modal.Body style={embeddedStyle.marginTopMinus20px}>
                            <div className={style.modalCard} onClick={handleShowForm}>
                                <Row>
                                    <Col md={1} sm={1} xs={2}>
                                        <Image src={form_icon} style={{ marginRight: '10px' }} />
                                    </Col>
                                    <Col md={10} sm={10} xs={10}>
                                        <p className={style.grayTextColor}>
                                            <b className={style.blackTextColor}>Complete a form</b><br></br>
                                        This will take you to a page where you will be required to provide answers to a couple of questions
                                    </p>
                                    </Col>
                                </Row>
                            </div>
                            <br></br>
                            <div className={style.modalCard} onClick={handleShowMail}>
                                <Row>
                                    <Col md={1} sm={1} xs={2}>
                                        <Image src={mail_icon} style={{ marginRight: '10px' }} />
                                    </Col>
                                    <Col md={10} sm={10} xs={10}>

                                        <p className={style.grayTextColor}>
                                            <b className={style.blackTextColor}>Send an email</b><br></br>
                                        Please send an email to the KPMG Ethics Line email address
                                    </p>
                                    </Col>
                                </Row>
                            </div>
                            <br></br>

                            <div className={style.modalCard} onClick={handleShowCall}>
                                <Row>
                                    <Col md={1} sm={1} xs={2}>
                                        <Image src={phone_icon} style={{ marginRight: '10px' }} />
                                    </Col>
                                    <Col md={10} sm={10} xs={10}>

                                        <p className={style.grayTextColor}>
                                            <b className={style.blackTextColor}>Make a call</b><br></br>
                                        Make a call to our toll-free mobile number, available for all networks
                                    </p>
                                    </Col>
                                </Row>
                            </div>
                            <br></br>
                            <div className={style.modalCard} onClick={handleShowPost}>
                                <Row>
                                    <Col md={1} sm={1} xs={2}>
                                        <Image src={post_icon} style={{ marginRight: '10px' }} />
                                    </Col>
                                    <Col md={10} sm={10} xs={10}>

                                        <p className={style.grayTextColor}>
                                            <b className={style.blackTextColor}>Mail report</b><br></br>
                                            Send in your report by post to the KPMG Office
                                    </p>
                                    </Col>
                                </Row>
                            </div>

                            {/* <Row style={{ marginTop: '27px' }}>
                                <Col md={12}>
                                    <p style={{ fontSize: "12px" }}><Image src={shield_user_icon} style={{ marginRight: '10px' }} />Your response is anonymous irrespective of your preferred approach</p>
                                </Col>
                            </Row> */}
                        </Modal.Body>
                    </div>
                    : <></>}


                {/* form */}
                {homeState.showForm ?
                    <div>
                        <Form onSubmit={submitReport}>





                            <Modal.Header style={{ borderColor: "transparent" }}>
                                <Modal.Title style={{ fontSize: "18px" }}>
                                    <p style={{ fontSize: "18px", float: "right" }}>
                                        <Image src={arrow_back} style={{ marginRight: '10px' }} onClick={handleCloseForm} />
                                        <Image src={form_icon} style={{ marginRight: '10px' }} />
                                    Fill a Form
                                    <span style={{ float: "right", marginLeft: "100px" }}>
                                            <Button letiant="light" style={{ backgroundColor: "#EDEDEE", fontSize: "14px", marginRight: "20px" }} onClick={handleCloseForm}>Cancel</Button>
                                            <Button type="submit" disabled={homeState.sendingReport} style={{ backgroundColor: "#005EB8", fontSize: "14px", }}>
                                                {homeState.sendingReport ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" style={{ marginRight: "10px" }} /> : <></>}
                                                Submit Report
                                                </Button>
                                        </span>
                                    </p>
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body style={embeddedStyle.marginTopMinus20px}>
                                <div>

                                    <Row>
                                        <Col md={12}>

                                            <Form.Group controlId="formReferenceNo" style={{ fontSize: "12px" }}>
                                                {/* <Form.Label >Organisation name<b style={{ color: "red" }}>*</b></Form.Label> */}
                                                {/* <Form.Control list="browsers" name="Organisation" required={true} onChange={handleReportFormChange} type="text" placeholder="Type here..." style={{ fontSize: "12px", backgroundColor: "#F1F3F3", borderRadius: "6px", borderColor: "transparent" }} /> */}
                                                <AutoSuggest
                                                    options={homeState.clientList}
                                                    handleChange={setClient}
                                                    value={client}
                                                    name="Organisation name*"
                                                    styles={{ searchLabel: { fontSize: "12px" }, searchField: { fontSize: "12px", backgroundColor: "#F1F3F3", borderRadius: "6px", borderColor: "transparent", width: "465px", height: "40px" } }}
                                                />
                                            </Form.Group>
                                            <Form.Group controlId="formReferenceNo" style={{ fontSize: "12px" }}>
                                                <Form.Label >Address/Location of incident (optional)</Form.Label>
                                                <Form.Control name="address" required={false} onChange={handleReportFormChange} type="text" placeholder="Type here..." style={{ fontSize: "12px", backgroundColor: "#F1F3F3", borderRadius: "6px", height: "40px", borderColor: "transparent" }} />
                                            </Form.Group>

                                            <Form.Row>
                                                <Form.Group as={Col} controlId="formGridEmail" style={{ fontSize: "12px" }}>
                                                    <Form.Label >Incident type<b style={{ color: "red" }}>*</b></Form.Label>
                                                    <Form.Control as="select" name="IncidentType" required={true} onChange={handleReportFormChange} style={{ fontSize: "12px", backgroundColor: "#F1F3F3", borderRadius: "6px", height: "40px", borderColor: "transparent" }}>
                                                        <option disabled selected value="">select an option</option>
                                                        {homeState.IncidentTypeList.map((i, key) => <option key={i.Name} value={i.Name}>{i.Name}</option>)}
                                                    </Form.Control>
                                                </Form.Group>
                                                <Form.Group as={Col} controlId="formGridPassword" style={{ fontSize: "12px" }}>
                                                    <Form.Label>Date of incident<b style={{ color: "red" }}>*</b></Form.Label>
                                                    <Form.Control name="date" required={true} onChange={handleReportFormChange} type="date" placeholder="Select date" style={{ fontSize: "12px", backgroundColor: "#F1F3F3", borderRadius: "6px", height: "40px", borderColor: "transparent" }} />
                                                </Form.Group>
                                            </Form.Row>

                                            <Form.Group controlId="formReferenceNo" style={{ fontSize: "12px" }}>
                                                <Form.Label >How did you get to know (optional)</Form.Label>
                                                <Form.Control as="textarea" name="how" required={false} onChange={handleReportFormChange} rows={3} placeholder="Brief description" style={{ fontSize: "12px", backgroundColor: "#F1F3F3", borderRadius: "6px", borderColor: "transparent" }} />
                                            </Form.Group>
                                            <Form.Group controlId="formReferenceNo" style={{ fontSize: "12px" }}>
                                                <Form.Label >Name(s) of persons involved (optional) - separate with a comma (,)</Form.Label>
                                                <Form.Control name="parties" required={false} onKeyUp={handleReportFormChange} type="text" placeholder="Type here..." style={{ fontSize: "12px", backgroundColor: "#F1F3F3", borderRadius: "6px", height: "40px", borderColor: "transparent" }} />
                                            </Form.Group>
                                            <Form.Group controlId="formReferenceNo" style={{ fontSize: "12px" }}>
                                                <Form.Label >Detailed description of the incident using times, datess, places and names where possible. Indicate WHO, WHAT, WHEN and HOW as to the incidenct<b style={{ color: "red" }}>*</b></Form.Label>
                                                <Form.Control as="textarea" name="Description" required={true} onChange={handleReportFormChange} rows={3} placeholder="Type here..." style={{ fontSize: "12px", backgroundColor: "#F1F3F3", borderRadius: "6px", borderColor: "transparent" }} />
                                            </Form.Group>
                                            <Form.Group controlId="formReferenceNo" style={{ fontSize: "12px" }}>
                                                <Form.Label >Supporting Audio/Video file (optional)</Form.Label>
                                                {/* <Form.Control type="file" name="file" required={true} onChange={handleReportFormChange} placeholder="Browse audio or video..." style={{ fontSize: "12px", backgroundColor: "#F1F3F3", borderRadius: "6px", borderColor: "transparent" }} /> */}
                                                <Form.File
                                                    style={{ fontSize: "12px", backgroundColor: "#F1F3F3", borderRadius: "6px", height: "40px", borderColor: "transparent" }}
                                                    name="file"
                                                    onChange={handleReportFormChange}
                                                    id="custom-file-translate-scss"
                                                    label={reportFormData.file?.length ? reportFormData.file[0].name : "Browse audio, image, or video..."}
                                                    data-browse="Upload"
                                                    lang="en"
                                                    accept={allowedUploadExtensions}
                                                    custom
                                                    multiple={true}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </div>
                            </Modal.Body>
                        </Form>
                    </div>
                    : <></>}

                {/* emails */}
                {homeState.showEmail ?
                    <div>
                        <Modal.Header closeButton style={{ borderColor: "transparent" }}>
                            <Modal.Title style={{ fontSize: "18px" }}>
                                <p style={{ fontSize: "18px" }}>
                                    <Image src={arrow_back} style={{ marginRight: '10px' }} onClick={handleCloseMail} />
                                    <Image src={mail_icon} style={{ marginRight: '10px' }} />
                                    Send an Email
                                    </p>
                                <p style={{ fontSize: "14px", fontFamily: "Circular Std" }}>Please send an email to the KPMG Ethics Line email address:</p>
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body style={embeddedStyle.marginTopMinus20px}>
                            <div>
                                <Row>
                                    <Col md={12}>

                                        <p style={{ fontSize: "18px", fontFamily: "Circular Std", color: "#00A3A1", backgroundColor: "#F1F3F3", borderRadius: "6px", borderColor: "transparent", padding: "16px 21px" }}>
                                            kpmgethicsline@ng.kpmg.com
                                            <OverlayTrigger trigger="click" placement="top-end" overlay={popover}>
                                                <Image onClick={copy} src={green_copy_icon} style={{ marginLeft: '10px', float: "right" }} />
                                            </OverlayTrigger>
                                        </p>
                                    </Col>
                                </Row>

                            </div>
                        </Modal.Body>
                    </div>
                    : <></>}

                {/* call */}
                {homeState.showCall ?
                    <div>
                        <Modal.Header closeButton style={{ borderColor: "transparent" }}>
                            <Modal.Title style={{ fontSize: "18px" }}>
                                <p style={{ fontSize: "18px" }}>
                                    <Image src={arrow_back} style={{ marginRight: '10px' }} onClick={handleCloseCall} />
                                    <Image src={phone_icon} style={{ marginRight: '10px' }} />
                                        Make call
                                    </p>
                                <p style={{ fontSize: "14px", fontFamily: "Circular Std" }}>Choose any phone number from your preferred network service provider:</p>
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body style={embeddedStyle.marginTopMinus20px}>
                            <div>
                                <Row>
                                    <Col md={12}>
                                        <p style={{ fontSize: "14px", fontFamily: "Circular Std" }}><b>- Mtn Toll Free Number:</b></p>
                                        <p style={{ fontSize: "12px", fontFamily: "Circular Std" }}>07030000026, 07030000027</p>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <p style={{ fontSize: "14px", fontFamily: "Circular Std" }}><b>- Airtel Toll Free Number:</b></p>
                                        <p style={{ fontSize: "12px", fontFamily: "Circular Std" }}>08088228888, 07080601222</p>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <p style={{ fontSize: "14px", fontFamily: "Circular Std" }}><b>- 9Mobile Toll Free Number:</b></p>
                                        <p style={{ fontSize: "12px", fontFamily: "Circular Std" }}>08099336366</p>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <p style={{ fontSize: "14px", fontFamily: "Circular Std" }}><b>- Glo Toll Free Number:</b></p>
                                        <p style={{ fontSize: "12px", fontFamily: "Circular Std" }}>07058890140</p>
                                    </Col>
                                </Row>
                            </div>
                        </Modal.Body>
                    </div>
                    : <></>}


                {/* post */}
                {homeState.showPost ?
                    <div>
                        <Modal.Header closeButton style={{ borderColor: "transparent" }}>
                            <Modal.Title style={{ fontSize: "18px" }}>
                                <p style={{ fontSize: "18px" }}>
                                    <Image src={arrow_back} style={{ marginRight: '10px' }} onClick={handleClosePost} />
                                    <Image src={post_icon} style={{ marginRight: '10px' }} />
                                        Send by Post
                                    </p>
                                <p style={{ fontSize: "14px", fontFamily: "Circular Std" }}>Send your report by post to the KPMG Office at:</p>
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body style={embeddedStyle.marginTopMinus20px}>
                            <div>
                                <Row>
                                    <Col md={12}>
                                        <p style={{ fontSize: "14px", fontFamily: "Circular Std" }}>KPMG Ethics Line</p>
                                        <p style={{ fontSize: "12px", fontFamily: "Circular Std" }}>KPMG Tower</p>
                                        <p style={{ fontSize: "12px", fontFamily: "Circular Std" }}>Bishop Aboyade Cole Street</p>
                                        <p style={{ fontSize: "12px", fontFamily: "Circular Std" }}>Victoria Island, Lagos.</p>
                                    </Col>
                                </Row>
                            </div>
                        </Modal.Body>
                    </div>
                    : <></>}

            </Modal>

            {/* Report success modal*/}
            <Modal show={homeState.showReportSuccess} onHide={handleCloseReportSuccessModal}   >
                <Modal.Header closeButton style={{ borderColor: "transparent" }}>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <center>
                            <p>
                                <Image src={tick_icon} style={{ width: "72px" }} />
                            </p>
                            <p style={{ fontSize: "24px" }}>
                                <b>Report Submitted</b>
                            </p>
                            <p style={{ fontSize: "14px" }}>
                                Thank you for making the report.
                                </p>
                            <p style={{ fontSize: "14px", marginTop: "-15px" }}>
                                Please take note of the Reference Number and keep it safe as you will need it to obtain feedback and updates on this report.
                                    </p>
                            <br></br>
                            <p style={{ fontSize: "18px", fontFamily: "Circular Std", color: "#005EB8", backgroundColor: "#F1F3F3", borderRadius: "6px", borderColor: "transparent", padding: "16px 21px" }}>
                                Reference Number -  {homeState.refNo}

                                <OverlayTrigger trigger="click" placement="top-end" overlay={popover}>
                                    <Image onClick={copy} src={copy_icon} style={{ marginLeft: '10px', float: "right" }} />
                                </OverlayTrigger>
                            </p>
                        </center>
                    </div>
                </Modal.Body>

            </Modal>

            {/* track report modal */}
            <Modal show={homeState.showTrackReportModal} onHide={handleCloseTrackReportModal}   >

                {!homeState.showFeedback ?
                    (<div>
                        <Modal.Header closeButton style={{ borderColor: "transparent" }}>
                            <Modal.Title style={{ fontSize: "24px" }}>Track Report</Modal.Title>

                        </Modal.Header>
                        <Form onSubmit={getFeedback}>
                            <Modal.Body>
                                <p style={{ fontSize: "14px", fontFamily: "Circular Std" }}>Please type in the reference number relating to the report you would like to get feedback on</p>
                                <div>
                                    <Row>
                                        <Col md={12}>

                                            <Form.Group controlId="formReferenceNo" style={{ fontSize: "12px" }}>
                                                <Form.Label >Reference number<b style={{ color: "red" }}>*</b></Form.Label>
                                                <Form.Control type="text" name="incidentRefNo" required={true} onChange={handleFeedbackFormChange} placeholder="Type here..." style={{ fontSize: "12px", backgroundColor: "#F1F3F3", borderRadius: "6px", height: "40px", borderColor: "transparent" }} />
                                            </Form.Group>


                                        </Col>
                                    </Row>
                                </div>
                            </Modal.Body>
                            <Modal.Footer style={{ borderColor: "transparent" }}>
                                <Button letiant="light" style={{ backgroundColor: "#EDEDEE", fontSize: "14px" }} onClick={handleCloseTrackReportModal}>Cancel</Button>
                                <Button letiant="success" type="submit" disabled={homeState.fetchingFeedback} style={{ backgroundColor: "#00A3A1", fontSize: "14px" }}>
                                    {homeState.fetchingFeedback ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" style={{ marginRight: "10px" }} /> : <></>}
                                        Feedback
                                    </Button>
                            </Modal.Footer>
                        </Form>
                    </div>) :
                    (<div>
                        <Modal.Header closeButton style={{ borderColor: "transparent" }} onHide={handleCloseFeedback}>
                            <Modal.Title style={{ fontSize: "18px" }}>
                                <p style={{ fontSize: "18px" }}>
                                    <Image src={arrow_back} style={{ marginRight: '10px' }} onClick={handleCloseFeedback} />
                                    <Image src={message_icon} style={{ marginRight: '10px' }} />
                                        Feedback
                                    </p>
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div>
                                <Row>
                                    <Col md={12}>
                                        <MultilineText>
                                            {homeState.reportFeedback}
                                        </MultilineText>
                                    </Col>
                                </Row>
                            </div>
                        </Modal.Body>
                    </div>)}

            </Modal>

            {/* How it works modal */}
            <Modal show={homeState.showHiwModal} onHide={handleCloseHiwModal}   >
                <Modal.Header closeButton style={{ borderColor: "transparent" }}>
                    <Modal.Title style={{ fontSize: "24px" }}>How It Works</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <Row>
                            <Col md={12}>
                                <Image src={hiw_img} style={{ width: "100%" }} />
                            </Col>
                        </Row>
                        <br />
                        <Row>
                            <Col md={12}>
                                <ol className={style.ol} style={{ width: '100%', fontSize: "14px" }}>
                                    <li className={style.li}>The whistleblower reaches out KPMG Ethics Line via our toll-free telephone lines, email, mobile app or web form.</li>
                                    <li className={style.li}>KPMG Ethics Line receives complaint from whistleblower and obtains relevant information from the whistleblower.</li>
                                    <li className={style.li}>KPMG Ethics Line generates a report from the details of the complaint and communicates this to the right level of management and/or board of directors of the client for further action (depending on the nature of complaint). The reports sent from the KPMG Ethics Line is carefully worded to remove any peice of information that can reveal the identity of the whistleblower.</li>
                                    <li className={style.li}>The client provides feedback to KPMG Ethics line based on its investigations on the complaint.</li>
                                    <li className={style.li}>KPMG provides feedback to the complainant.</li>
                                </ol>
                            </Col>
                        </Row>
                    </div>
                </Modal.Body>

            </Modal>

            {/* FAQs modal */}
            <Modal show={homeState.showFaqModal} onHide={handleCloseFaqModal} size="lg">
                <Modal.Header closeButton style={{ borderColor: "transparent" }}>
                    <Modal.Title style={{ fontSize: "24px" }}>Frequently Asked Questions - FAQs</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        {
                            faqs.map((element) => {
                                return (
                                    <>
                                        <Collapsible triggerStyle={embeddedStyle.collapsibleTrigger} trigger={<div>{element.question}<Image src={open_icon} style={{ float: "right" }} /></div>} triggerWhenOpen={<div>{element.question}<Image src={close_icon} style={{ float: "right" }} /></div>}>
                                            <p style={embeddedStyle.collapsibleText}>{element.answer}</p>
                                        </Collapsible>
                                        <hr></hr>
                                    </>
                                )
                            })
                        }
                    </div>
                </Modal.Body>

            </Modal>
        </>

    );
}

const embeddedStyle = {
    collapsibleTrigger: { color: "#A42275", fontSize: "16px", fontFamily: "Circular Std" },
    collapsibleText: { marginTop: "9px", marginBottom: "0px", fontSize: "12px" },
    marginTopMinus20px: { marginTop: "-20px" }
}

export default Home;



